<template>
  <div>
    <div class="row">
      <div class="col-6">
        <button class="btn btn-light" @click="refresh()"><i class="fa fa-sync fa-fw" aria-hidden="true"></i> Refresh</button>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-12">
        <table class="table table-hover table-sm">
          <thead>
            <tr>
              <th scope="col">Username</th>
              <th scope="col">Table</th>
              <th scope="col">Before</th>
              <th scope="col">After</th>
              <th scope="col">Timestamp</th>
            </tr>
          </thead>
          <tbody>
          <tr v-for="audit in audits" :key="audit.id">
            <td>{{ audit.username }}</td>
            <td>{{ audit.table_name }}</td>
            <td>{{ audit.object_before }}</td>
            <td>{{ audit.object_after }}</td>
            <td>{{ audit.timestamp }}</td>
          </tr>
          </tbody>
        </table>
        <nav>
          <ul class="pagination">
            <li class="page-item" v-for="n in log_total_pages"
                :key="n"
                :class="{ 'active': n === log_current_page }">
              <a class="page-link" href="#" v-if="n === 1"
                 onclick="return false"
                 @click="loadAudit(n)">{{ n }}</a>
              <a class="page-link" v-else-if="n === (log_current_page - 4)">
                ...
              </a>
              <a class="page-link" href="#" v-else-if="(n) <= (log_current_page + 3) && n >= (log_current_page - 3)"
                 onclick="return false"
                 @click="loadAudit(n)">{{ n }}</a>
              <a class="page-link" href="#" v-else-if="n === log_total_pages"
                 onclick="return false"
                 @click="loadAudit(n)">{{ n }}</a>
              <a class="page-link" v-else-if="n === (log_current_page + 4)">
                ...
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      audits: 'allAudit',
      log_total_pages: 'auditTotalPages',
      log_current_page: 'auditCurrentPage',
      scoped_site_id: 'scopedSiteId'
    })
  },
  created () {
    this.$store.dispatch('getAudit', {
      page: '1'
    })
  },
  methods: {
    loadAudit (page) {
      this.$store.dispatch('getAudit',
        {
          page: page
        }
      )
    },
    refresh () {
      this.$store.dispatch('getAudit', {
        page: '1'
      })
    }
  }
}
</script>

<style scoped>

</style>
